export const excludedDurationBrands = [
  'GIH',
  'Berlin School of Business and Innovation',
]
